import { AppRoute } from '@agentselly/immodossier-shared';
import { createFileRoute } from '@tanstack/react-router';
import { RenderWidgets } from '~/components/widget/RenderWidgets';

export const Route = createFileRoute<any, any, any, any>(
  AppRoute.$LANG_$COMPANYID_PUBLIC_CONTACT,
)({
  component: function Body() {
    return (
      <RenderWidgets
        widgets={[
          {
            name: 'hubspotForm',
            cols: 4,
            props: {
              // Brand-neutral heading (no "AgentSelly"). New Tolgee key with a
              // German default fallback so it renders correctly even before the
              // translation is added remotely.
              title: 'contact_form_title_neutral',
              titleDefault: 'Nachricht an uns',
              description: 'contact_form_text',
              portalId: '26776524',
              formId: '9e9d404c-4901-450d-b9bb-3fea2f96c6cf',
              guestFormId: '0bb35717-a8d8-4bc8-a9c4-98f36c2039d4',
              bookingUrl:
                'https://meetings-eu1.hubspot.com/martin-heim/15-min-meeting-kostenlose-beratung-',
            },
          },
        ]}
      />
    );
  },
});
